module.exports = __webpack_public_path__ + "static/media/1001002HG.88477f19.jpg";